import clsx from 'clsx';
import { FormatUtils } from '@shared/utils';
import { UserWithPaymentInfo } from '@shared/api/rest/users';
import { Icon } from '@shared/widgets';
import ReportIcon from '@assets/icons/report.svg';
import MailIcon from '@assets/icons/mail.svg';
import PhoneIcon from '@assets/icons/phone.svg';

interface IUserContactsProps {
  user: UserWithPaymentInfo;
}

export const UserContacts = (props: IUserContactsProps) => {
  return (
    <ul
      className={clsx(
        'font-medium text-sm my-0 w-full z-[1000] bg-white dark:bg-soft-black overflow-auto max-h-[300px] px-6 pb-8',
        props.user.locked && 'opacity-50',
      )}
    >
      {props.user.position && (
        <li className='mb-4 flex items-center gap-2'>
          <Icon icon={<ReportIcon width='18' height='18' />} color='primary' />
          {props.user.position}
        </li>
      )}
      {props.user.emailAddress && (
        <li className='mb-4 flex items-center gap-2'>
          <Icon icon={<MailIcon />} color='primary' />
          {props.user.emailAddress}
        </li>
      )}
      {props.user.phoneAreaCode && props.user.phoneNumber && (
        <li className='flex items-center gap-2'>
          <Icon icon={<PhoneIcon />} color='primary' />
          {FormatUtils.toPhoneFormat(props.user.phoneAreaCode, props.user.phoneNumber)}
        </li>
      )}
    </ul>
  );
};
